import * as React from 'react';

import { IOptionProps } from '../types';

export class Option extends React.Component<IOptionProps> {
  public render() {
    return this.props.children;
  }
}
